// src/components/Auth/RequireAuth.jsx
import { Navigate } from 'react-router-dom';

export default function RequireAuth({ user, children }) {
  if (!user) {
    return <Navigate to="/auth/signin" replace />;
  }

  return children;
}
